import React from 'react';
import { Spinner } from 'bv-components';
import withLazyLoad from 'bv-lazy-load';

const embeddedLazyLoad = withLazyLoad(<Spinner />);

const OpenBets = embeddedLazyLoad('sportsbookCashout');

export default OpenBets;
